import { Button } from '../../components/Button';

/**
 * Full-screen takeover shown when the API returns 403 DEVICE_NOT_TRUSTED — the
 * user is authenticated but not on a company-issued device (and lacks the
 * remote_access bypass). Deliberately non-technical.
 */
export function DeviceUntrustedScreen({ onLogout }: { onLogout: () => void }): JSX.Element {
  return (
    <div className="min-h-screen flex items-center justify-center bg-paper px-6">
      <div className="max-w-md text-center space-y-5">
        <div className="kc-serif text-5xl text-ink">Company device required</div>
        <p className="text-sm text-ink-3 leading-relaxed">
          For security, this account can only be used on a company-issued device. Please switch to
          your registered work device, or contact your administrator if you believe this device
          should be approved.
        </p>
        <div className="pt-2">
          <Button variant="secondary" onClick={onLogout}>
            Sign in with a different account
          </Button>
        </div>
      </div>
    </div>
  );
}
